module.exports = __webpack_public_path__ + "img/5.87fe1b09.png";